import { Box, useMediaQuery, useTheme } from "@mui/material";
import Lottie from "lottie-react";
import RotoLogo from "../../assets/RotoLogo.json";
import { useState } from "react";

interface SimpleSplashScreenProps {
  onVideoEnd: () => void;
}

const VIDEO_URL = "https://storage.googleapis.com/roto-logos-roto-gpt-dev-zyx/RotoGPTAnimatedblack.mp4";

const SimpleSplashScreen = ({ onVideoEnd }: SimpleSplashScreenProps) => {
  const [isAnimationEnded, setIsAnimationEnded] = useState(false);
  const [isAnimationLoaded, setIsAnimationLoaded] = useState(false);

  const theme = useTheme();
  // For mobile (less than 600px)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // For tablets (between 600px and 1200px)
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#000000",
        pointerEvents: "none",
        zIndex: 9999,
        opacity: isAnimationEnded ? 0 : 1,
        transition: "opacity 1s ease-in-out",
      }}
    >
      <Lottie
        animationData={RotoLogo}
        loop={false}
        autoplay
        onComplete={() => {
          setIsAnimationEnded(true);
          setTimeout(() => {
            onVideoEnd();
          }, 1000);
        }}
        onLoadedImages={() => {
          setTimeout(() => setIsAnimationLoaded(true), 100);
        }}
        style={{
          width: isMobile ? "100%" : isTablet ? "50%" : "50%", //volver a 100% cuando sea RotoGPT logo
          height: isMobile ? "100%" : isTablet ? "50%" : "50%", //volver a 100% cuando sea RotoGPT logo
          opacity: 1,
          transition: "opacity 1s ease-in-out",
        }}
      />
    </Box>
  );
};

export default SimpleSplashScreen;
